import { useTranslation } from '~/hooks';
import type { HubPagination } from '~/utils/hubPage';

/** The title or description of a page of a city, job or sector page's offers: each page has its own, as each is indexed. */
export const useHubPageMeta = (text: string, { currentPage }: HubPagination) => {
  const t = useTranslation();
  return currentPage > 1 ? `${t('latest_job_offers.page', { page: currentPage })} - ${text}` : text;
};
